import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  public user: any;
  public isLogin!: boolean;

  rcmRecordPermissionList: any = [];
  insACQRecordPermissionList:any=[];
  insuranceFormRecordPermissionList: any = [];
  mceRecordPermissionList: any = [];

  workbenchPermissionList: any = [];
  insACQworkbenchPermissionList:any=[];
  insuranceFormworkbenchPermissionList: any = [];
  mceworkbenchPermissionList: any = [];

  schedulePermissionList: any = [];
  insACQschedulePermissionList :any=[];
  insuranceFormschedulePermissionList: any = [];
  mceschedulePermissionList: any = [];

  uploadWorkbenchPermissionList: any = [];
  insACQuploadWorkbenchPermissionList:any=[];
  insuranceFormuploadWorkbenchPermissionList: any = [];
  mceuploadWorkbenchPermissionList: any = [];

  auditReportPermissionList: any = [];
  insACQauditReportPermissionList :any=[];
  insuranceFormauditReportPermissionList: any = [];
  mceauditReportPermissionList: any = [];

  userPermissionList: any = [];
  reviewCrawlPermissionList: any = [];
  missedActionPermissionList: any = [];
  instanceAndSchedulesPermissionList: any = [];
  missedDataPermissionList: any = [];
  syncRCMDataPermissionList:any=[];
  getCrawledDataPermissionList:any=[];
  manageSummaryParameterMappingPermissionList:any=[];
  rcmInstructiondetailsPermissionList:any=[];
  insAcqInstructiondetailsPermissionList:any=[];
  manageRecrawlURLConfigPermissionList:any=[];
  manageQueryBuilderPermissionList:any=[];

  insFormInstructiondetailsPermissionList:any=[];
  mceInstructiondetailsPermissionList:any=[];
 
  private router: Router;

  constructor(router: Router,) {
    this.router = router;
  }

  private userObs = new Subject<string>();
  userObs$ = this.userObs.asObservable();

  private menuObs = new Subject<string>();
  menuObs$ = this.menuObs.asObservable();

  public SetUserData(user: any) {
    this.user = user;
    if (user) {
      this.isLogin = true;
    }
    else {
      this.isLogin = false;
    }
    this.userObs.next(user?.UserMasterID);
  }

  public SetMenuData(menuDetails: any, menu: number,successCount : number) {
    if (menu == 1) {
      sessionStorage.setItem("rcmRecordPermissionList", menuDetails);
      this.rcmRecordPermissionList = sessionStorage.getItem("rcmRecordPermissionList");
      //console.log('rcmRecordPermissionList'+this.rcmRecordPermissionList)
    }
    if (menu == 2) {
      sessionStorage.setItem("workbenchPermissionList", menuDetails);
      this.workbenchPermissionList = sessionStorage.getItem("workbenchPermissionList");
      //console.log('workbenchPermissionList'+this.workbenchPermissionList)
    }
    if (menu == 3) {
      sessionStorage.setItem("uploadWorkbenchPermissionList", menuDetails);
      this.uploadWorkbenchPermissionList = sessionStorage.getItem("uploadWorkbenchPermissionList");
      //console.log('uploadWorkbenchPermissionList'+this.uploadWorkbenchPermissionList)
    }
    if (menu == 4) {
      sessionStorage.setItem("schedulePermissionList", menuDetails);
      this.schedulePermissionList = sessionStorage.getItem("schedulePermissionList");
      //console.log('schedulePermissionList'+this.schedulePermissionList)
    }
    if (menu == 5) {
      sessionStorage.setItem("auditReportPermissionList", menuDetails);
      this.auditReportPermissionList = sessionStorage.getItem("auditReportPermissionList");
      //console.log('auditReportPermissionList'+this.auditReportPermissionList)
    }
    if (menu == 6) {
      sessionStorage.setItem("userPermissionList", menuDetails);
      this.userPermissionList = sessionStorage.getItem("userPermissionList");
      //console.log('userPermissionList'+this.userPermissionList)
    }
    
    //Insurance ACQ
    if (menu == 7) {
      sessionStorage.setItem("insACQRecordPermissionList", menuDetails);
      this.insACQRecordPermissionList = sessionStorage.getItem("insACQRecordPermissionList");
      //console.log('insACQRecordPermissionList'+this.insACQRecordPermissionList)
    }
    
    if (menu == 8) {
      sessionStorage.setItem("insACQworkbenchPermissionList", menuDetails);
      this.insACQworkbenchPermissionList = sessionStorage.getItem("insACQworkbenchPermissionList");
      //console.log('insACQworkbenchPermissionList'+this.insACQworkbenchPermissionList)
    }

    if (menu == 9) {
      sessionStorage.setItem("insACQuploadWorkbenchPermissionList", menuDetails);
      this.insACQuploadWorkbenchPermissionList = sessionStorage.getItem("insACQuploadWorkbenchPermissionList");
      //console.log('insACQuploadWorkbenchPermissionList'+this.insACQuploadWorkbenchPermissionList)
    }

    if (menu == 10) {
      sessionStorage.setItem("insACQauditReportPermissionList", menuDetails);
      this.insACQauditReportPermissionList = sessionStorage.getItem("insACQauditReportPermissionList");
      //console.log('insACQauditReportPermissionList'+this.insACQauditReportPermissionList)
    }

    if (menu == 11) {
      sessionStorage.setItem("insACQschedulePermissionList", menuDetails);
      this.insACQschedulePermissionList = sessionStorage.getItem("insACQschedulePermissionList");
      //console.log('insACQschedulePermissionList'+this.insACQschedulePermissionList)
    }
    
    //Insurance Form
    if (menu == 12) {
      sessionStorage.setItem("insuranceFormRecordPermissionList", menuDetails);
      this.insuranceFormRecordPermissionList = sessionStorage.getItem("insuranceFormRecordPermissionList");
      //console.log('insuranceFormRecordPermissionList'+this.insuranceFormRecordPermissionList)
    }

    if (menu == 13) {
      sessionStorage.setItem("insuranceFormworkbenchPermissionList", menuDetails);
      this.insuranceFormworkbenchPermissionList = sessionStorage.getItem("insuranceFormworkbenchPermissionList");
      //console.log('insuranceFormworkbenchPermissionList'+this.insuranceFormworkbenchPermissionList)
    }

    if (menu == 14) {
      sessionStorage.setItem("insuranceFormuploadWorkbenchPermissionList", menuDetails);
      this.insuranceFormuploadWorkbenchPermissionList = sessionStorage.getItem("insuranceFormuploadWorkbenchPermissionList");
      //console.log('insuranceFormuploadWorkbenchPermissionList'+this.insuranceFormuploadWorkbenchPermissionList)
    }

    if (menu == 15) {
      sessionStorage.setItem("insuranceFormauditReportPermissionList", menuDetails);
      this.insuranceFormauditReportPermissionList = sessionStorage.getItem("insuranceFormauditReportPermissionList");
      //console.log('insuranceFormauditReportPermissionList'+this.insuranceFormauditReportPermissionList)
    }

    if (menu == 16) {
      sessionStorage.setItem("insuranceFormschedulePermissionList", menuDetails);
      this.insuranceFormschedulePermissionList = sessionStorage.getItem("insuranceFormschedulePermissionList");
      //console.log('insuranceFormschedulePermissionList'+this.insuranceFormschedulePermissionList)
    }

    //MCE
    if (menu == 17) {
      sessionStorage.setItem("mceRecordPermissionList", menuDetails);
      this.mceRecordPermissionList = sessionStorage.getItem("mceRecordPermissionList");
      //console.log('mceRecordPermissionList'+this.mceRecordPermissionList)
    }

    if (menu == 18) {
      sessionStorage.setItem("mceworkbenchPermissionList", menuDetails);
      this.mceworkbenchPermissionList = sessionStorage.getItem("mceworkbenchPermissionList");
      //console.log('mceworkbenchPermissionList'+this.mceworkbenchPermissionList)
    }

    if (menu == 19) {
      sessionStorage.setItem("mceuploadWorkbenchPermissionList", menuDetails);
      this.mceuploadWorkbenchPermissionList = sessionStorage.getItem("mceuploadWorkbenchPermissionList");
      //console.log('mceuploadWorkbenchPermissionList'+this.mceuploadWorkbenchPermissionList)
    }

    if (menu == 20) {
      sessionStorage.setItem("mceauditReportPermissionList", menuDetails);
      this.mceauditReportPermissionList = sessionStorage.getItem("mceauditReportPermissionList");
      //console.log('mceauditReportPermissionList'+this.mceauditReportPermissionList)
    }

    if (menu == 21) {
      sessionStorage.setItem("mceschedulePermissionList", menuDetails);
      this.mceschedulePermissionList = sessionStorage.getItem("mceschedulePermissionList");
      //console.log('mceschedulePermissionList'+this.mceschedulePermissionList)
    }

    if (menu == 22) {
      sessionStorage.setItem("reviewCrawlPermissionList", menuDetails);
      this.reviewCrawlPermissionList = sessionStorage.getItem("reviewCrawlPermissionList");
      //console.log('reviewCrawlPermissionList'+this.reviewCrawlPermissionList)
    }

    if (menu == 23) {
      sessionStorage.setItem("missedActionPermissionList", menuDetails);
      this.missedActionPermissionList = sessionStorage.getItem("missedActionPermissionList");
      //console.log('missedActionPermissionList'+this.missedActionPermissionList)
    }

    if (menu == 24) {
      sessionStorage.setItem("instanceAndSchedulesPermissionList", menuDetails);
      this.instanceAndSchedulesPermissionList = sessionStorage.getItem("instanceAndSchedulesPermissionList");
      //console.log('instanceAndSchedulesPermissionList'+this.instanceAndSchedulesPermissionList)
    }

    if (menu == 25) {
      sessionStorage.setItem("missedDataPermissionList", menuDetails);
      this.missedDataPermissionList = sessionStorage.getItem("missedDataPermissionList");
      //console.log('missedDataPermissionList'+this.missedDataPermissionList)
    }
    if (menu == 26) {
      sessionStorage.setItem("syncRCMDataPermissionList", menuDetails);
      this.syncRCMDataPermissionList = sessionStorage.getItem("syncRCMDataPermissionList");
      //console.log('syncRCMDataPermissionList'+this.syncRCMDataPermissionList)
    }
    if (menu == 27) {
      sessionStorage.setItem("rcmInstructiondetailsPermissionList", menuDetails);
      this.rcmInstructiondetailsPermissionList = sessionStorage.getItem("rcmInstructiondetailsPermissionList");
      //console.log('rcmInstructiondetailsPermissionList'+this.rcmInstructiondetailsPermissionList)
    }
    if(menu==28){
      sessionStorage.setItem("insAcqInstructiondetailsPermissionList", menuDetails);
      this.insAcqInstructiondetailsPermissionList = sessionStorage.getItem("insAcqInstructiondetailsPermissionList");
      //console.log('insAcqInstructiondetailsPermissionList'+this.insAcqInstructiondetailsPermissionList)
    }
    if (menu == 29) {
      sessionStorage.setItem("insFormInstructiondetailsPermissionList", menuDetails);
      this.insFormInstructiondetailsPermissionList = sessionStorage.getItem("insFormInstructiondetailsPermissionList");
      //console.log('insFormInstructiondetailsPermissionList'+this.insFormInstructiondetailsPermissionList)
    }
    if (menu == 30) {
      sessionStorage.setItem("mceInstructiondetailsPermissionList", menuDetails);
      this.mceInstructiondetailsPermissionList = sessionStorage.getItem("mceInstructiondetailsPermissionList");
      //console.log('mceInstructiondetailsPermissionList'+this.mceInstructiondetailsPermissionList)
    }
    if (menu == 31) {
      sessionStorage.setItem("getCrawledDataPermissionList", menuDetails);
      this.getCrawledDataPermissionList = sessionStorage.getItem("getCrawledDataPermissionList");
      //console.log('mceInstructiondetailsPermissionList'+this.mceInstructiondetailsPermissionList)
    }
    if (menu == 32) {
      sessionStorage.setItem("manageSummaryParameterMappingPermissionList", menuDetails);
      this.manageSummaryParameterMappingPermissionList = sessionStorage.getItem("manageSummaryParameterMappingPermissionList");
      //console.log('mceInstructiondetailsPermissionList'+this.mceInstructiondetailsPermissionList)
    }
    if (menu == 33) {
      sessionStorage.setItem("manageRecrawlURLConfigPermissionList", menuDetails);
      this.manageRecrawlURLConfigPermissionList = sessionStorage.getItem("manageRecrawlURLConfigPermissionList");
      //console.log('mceInstructiondetailsPermissionList'+this.mceInstructiondetailsPermissionList)
    }
    if (menu == 34) {
      sessionStorage.setItem("manageQueryBuilderPermissionList", menuDetails);
      this.manageQueryBuilderPermissionList = sessionStorage.getItem("manageQueryBuilderPermissionList");
      //console.log('mceInstructiondetailsPermissionList'+this.mceInstructiondetailsPermissionList)
    }

   
    this.menuObs.next(menuDetails);
    if(successCount==34)
    {
      if (this.rcmRecordPermissionList == '0' && this.workbenchPermissionList == '0' && 
      this.uploadWorkbenchPermissionList == '0' && this.schedulePermissionList == '0' && 
      this.auditReportPermissionList == '0' && this.userPermissionList == '0' &&
      this.insACQRecordPermissionList == '0' && this.insACQworkbenchPermissionList == '0' &&
      this.insACQschedulePermissionList == '0' && this.insACQuploadWorkbenchPermissionList == '0' &&
      this.insACQauditReportPermissionList == '0' && this.insuranceFormRecordPermissionList == '0' &&
      this.insuranceFormworkbenchPermissionList == '0' && this.insuranceFormschedulePermissionList == '0' &&
      this.insuranceFormuploadWorkbenchPermissionList == '0' && this.insuranceFormauditReportPermissionList == '0' &&
      this.mceRecordPermissionList == '0' && this.mceworkbenchPermissionList == '0' && 
      this.mceschedulePermissionList == '0' && this.mceuploadWorkbenchPermissionList == '0' && 
      this.mceauditReportPermissionList == '0' && this.reviewCrawlPermissionList == '0' &&
      this.missedActionPermissionList == '0' && this.instanceAndSchedulesPermissionList == '0' &&
      this.missedDataPermissionList == '0' && this.syncRCMDataPermissionList == '0' &&
      this.rcmInstructiondetailsPermissionList=='0' && this.insAcqInstructiondetailsPermissionList=='0'&&
      this.insFormInstructiondetailsPermissionList=='0' && this.mceInstructiondetailsPermissionList=='0'&&
      this.getCrawledDataPermissionList=='0' && this.manageSummaryParameterMappingPermissionList =='0' &&
      this.manageRecrawlURLConfigPermissionList =='0' && this.manageQueryBuilderPermissionList == '0') {
        this.router.navigateByUrl('/Task')
      }
      else if (this.workbenchPermissionList != 0) {
          this.router.navigateByUrl('/Workbench');
      }
      //Insurance ACQ Workbench
      else if (this.insACQworkbenchPermissionList != 0) {
        this.router.navigateByUrl('/WorkbenchInsuranceACQ');
    }
      //Insurance Form Workbench
      else if (this.insuranceFormworkbenchPermissionList != 0) {
        this.router.navigateByUrl('/InsuranceFormWorkbench');
      }
      //MCE Workbench
      else if (this.mceworkbenchPermissionList != 0) {
        this.router.navigateByUrl('/WorkbenchMCE');
      }
      else {
        if (this.rcmRecordPermissionList != 0) {
          this.router.navigateByUrl('/RLSearch');
        }
        else if (this.auditReportPermissionList != 0) {
          this.router.navigateByUrl('/Report');
        }
        else if (this.schedulePermissionList != 0) {
          this.router.navigateByUrl('/ScheduleMaster');
        }
        else if (this.userPermissionList != 0) {
          this.router.navigateByUrl('/User');
        }
        else if (this.reviewCrawlPermissionList != 0) {
          this.router.navigateByUrl('/ReviewCrawledDataList');
        }
        else if (this.missedActionPermissionList != 0) {
          this.router.navigateByUrl('/MissedActionDataHistory');
        }
        else if (this.instanceAndSchedulesPermissionList != 0) {
          this.router.navigateByUrl('/UrlInstancesAndSchedulesListComponent');
        }
        else if (this.missedDataPermissionList != 0) {
          this.router.navigateByUrl('/ReviewMissedDataListComponent');
        }
        else if (this.syncRCMDataPermissionList != 0) {
          this.router.navigateByUrl('/SyncRcmMasterDataComponent');
        }
        else if (this.getCrawledDataPermissionList != 0) {
          this.router.navigateByUrl('/GetCrawledDataList');
        }
        else if (this.manageSummaryParameterMappingPermissionList != 0) {
          this.router.navigateByUrl('/SummaryGenerationParameterMapping');
        }
         else if (this.manageRecrawlURLConfigPermissionList != 0) {
          this.router.navigateByUrl('/RecrawlUrlConfiguration');
        }
        else if(this.manageQueryBuilderPermissionList != 0){
          this.router.navigateByUrl('/QueryBuilderComponent');
        }
        
        //Insurance ACQ
        if (this.insACQRecordPermissionList != 0) {
          this.router.navigateByUrl('/RLSearchInsuranceACQ');
        }
        else if (this.insACQauditReportPermissionList != 0) {
          this.router.navigateByUrl('/Report');
        }
        
        else if (this.insACQschedulePermissionList != 0) {
          this.router.navigateByUrl('/ScheduleMaster');
        }
        else if (this.userPermissionList != 0) {
          this.router.navigateByUrl('/User');
        }
        else if (this.reviewCrawlPermissionList != 0) {
          this.router.navigateByUrl('/ReviewCrawledDataList');
        }
        else if (this.missedActionPermissionList != 0) {
          this.router.navigateByUrl('/MissedActionDataHistory');
        }
        else if (this.instanceAndSchedulesPermissionList != 0) {
          this.router.navigateByUrl('/UrlInstancesAndSchedulesListComponent');
        }
        else if (this.missedDataPermissionList != 0) {
          this.router.navigateByUrl('/ReviewMissedDataListComponent');
        }

        //Insurance Form
        if (this.insuranceFormRecordPermissionList != 0) {
          this.router.navigateByUrl('/RLSearchInsuranceForm');
        }
        else if (this.insuranceFormauditReportPermissionList != 0) {
          this.router.navigateByUrl('/Report');
        }
        else if (this.insuranceFormschedulePermissionList != 0) {
          this.router.navigateByUrl('/ScheduleMaster');
        }
        else if (this.userPermissionList != 0) {
          this.router.navigateByUrl('/User');
        }
        else if (this.reviewCrawlPermissionList != 0) {
          this.router.navigateByUrl('/ReviewCrawledDataList');
        }
        else if (this.missedActionPermissionList != 0) {
          this.router.navigateByUrl('/MissedActionDataHistory');
        }
        else if (this.instanceAndSchedulesPermissionList != 0) {
          this.router.navigateByUrl('/UrlInstancesAndSchedulesListComponent');
        }
        else if (this.missedDataPermissionList != 0) {
          this.router.navigateByUrl('/ReviewMissedDataListComponent');
        }

        //MCE
        if (this.insuranceFormRecordPermissionList != 0) {
          this.router.navigateByUrl('/RLSearchMCE');
        }
        else if (this.insuranceFormauditReportPermissionList != 0) {
          this.router.navigateByUrl('/Report');
        }
        else if (this.insuranceFormschedulePermissionList != 0) {
          this.router.navigateByUrl('/ScheduleMaster');
        }
        else if (this.userPermissionList != 0) {
          this.router.navigateByUrl('/User');
        }
        else if (this.reviewCrawlPermissionList != 0) {
          this.router.navigateByUrl('/ReviewCrawledDataList');
        }
        else if (this.missedActionPermissionList != 0) {
          this.router.navigateByUrl('/MissedActionDataHistory');
        }
        else if (this.instanceAndSchedulesPermissionList != 0) {
          this.router.navigateByUrl('/UrlInstancesAndSchedulesListComponent');
        }
        else if (this.missedDataPermissionList != 0) {
          this.router.navigateByUrl('/ReviewMissedDataListComponent');
        }
      }
    }
  }

}
